import HeaderMain from './headerMain';
import MobileHeaderMain from '../../mobile/modules/common/headerMain';
import MobileFooterMain from '../../mobile/modules/common/footerMain';
import { tryInitMobileBottomNav } from '../../mobile/modules/common/navigationMain';
import SecondaryHeaderMain from './secondaryHeaderMain';
import FooterMain from './footerMain';
import { bindGlobalKefuClick } from '../../common/openKefu';
// import statisticalCodeMain from './statisticalCodeMain'
var CommonMain = /** @class */ (function () {
    function CommonMain() {
        if (document.getElementById('daetool-header')) {
            new HeaderMain();
        }
        if (document.getElementById('header')) {
            new MobileHeaderMain();
        }
        new SecondaryHeaderMain();
        if (document.getElementById('daetool-footer')) {
            new FooterMain();
            bindGlobalKefuClick();
        }
        if (document.getElementById('footer-mobile')) {
            new MobileFooterMain();
        }
        tryInitMobileBottomNav();
        // new statisticalCodeMain()
    }
    return CommonMain;
}());
export default CommonMain;
